var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_14363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82666 2.63765L1.21199 12.011C1.09631 12.2114 1.03511 12.4387 1.03449 12.6702C1.03387 12.9016 1.09383 13.1292 1.20843 13.3303C1.32303 13.5314 1.48827 13.699 1.68772 13.8164C1.88717 13.9338 2.11389 13.997 2.34533 13.9996H13.5753C13.8068 13.997 14.0335 13.9338 14.2329 13.8164C14.4324 13.699 14.5976 13.5314 14.7122 13.3303C14.8268 13.1292 14.8868 12.9016 14.8862 12.6702C14.8855 12.4387 14.8243 12.2114 14.7087 12.011L9.09333 2.63765C8.97509 2.44297 8.8087 2.28204 8.61019 2.17035C8.41169 2.05867 8.18776 2 7.95999 2C7.73223 2 7.5083 2.05867 7.30979 2.17035C7.11129 2.28204 6.9449 2.44297 6.82666 2.63765Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.66667",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.332H8.00667",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_14363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon04);
export default __webpack_public_path__ + "static/media/dashboard-icon-04.70ab81811ff45ebaafdf58532e55ba2d.svg";
export { ForwardRef as ReactComponent };